// entry/actionTypes.js

const DISPLAY_FORM = '@@entry/DISPLAY_FORM';
const CHANGE_VALUE = '@@entry/CHANGE_VALUE';
const RESET_VALUES = '@@entry/RESET_VALUES';

const REQUEST_LOGIN = '@@entry/REQUEST_LOGIN';
const LOGIN_RESPONSE = '@@entry/LOGIN_RESPONSE';

const REQUEST_FORGOT_PASSWORD = '@@entry/REQUEST_FORGOT_PASSWORD';
const FORGOT_PASSWORD_RESPONSE = '@@entry/FORGOT_PASSWORD_RESPONSE';

const REQUEST_ACCOUNT_REQUEST = '@@entry/REQUEST_ACCOUNT_REQUEST';
const ACCOUNT_REQUEST_RESPONSE = '@@entry/ACCOUNT_REQUEST_RESPONSE';

export default {
    CHANGE_VALUE,
    DISPLAY_FORM,
    RESET_VALUES,
    REQUEST_LOGIN,
    LOGIN_RESPONSE,
    REQUEST_FORGOT_PASSWORD,
    FORGOT_PASSWORD_RESPONSE,
    REQUEST_ACCOUNT_REQUEST,
    ACCOUNT_REQUEST_RESPONSE
};